import React from "react";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  return (
    <>
      <div className="d-flex">
        <div className="" style={{ width: "19%" }}>
          <Sidebar />
        </div>
        <div className="" style={{ width: "81%" }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default Layout;
